<template>
  <div v-loading="loading">
    <p class="tips">该功能需要设备开启wan访问才能正常使用,请在使用前先检查是否开启wan访问</p>
    <el-form :model="connectInfo" :inline="true">
      <el-form-item :label="$t('lang.FastAccess.deviceSn')"> {{ window_dsn }}</el-form-item>
      <el-form-item :label="$t('lang.Monitor.deviceAddress')" prop="hostname">
        <el-input disabled size="mini" v-model="connectInfo.hostname" class="webinput"></el-input>
      </el-form-item>
      <el-form-item :label="$t('lang.webssh.SelectRoute')" prop="ssH_password">
        <el-select v-model="connectInfo.networkLine" size="mini">
          <el-option :label="$t('lang.webssh.DEFAULT')" value="DEFAULT"></el-option>
          <el-option :label="$t('lang.ConfigSetting.ChinaMobile')" value="CHINA_MOBILE"></el-option>
          <el-option :label="$t('lang.ConfigSetting.ChinaTelecom')" value="CHINA_TELECOM"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="mini" :disabled="connectInfo.hostname !== ''" type="primary" @click="connect">建立连接</el-button>
        <el-button size="mini" type="danger" @click="unconnect">断开</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getWebsshUrl, removeDeviceIp, heartBeat, pingIp, logError } from "@/api/particulars";
import { getDeviceMqttStatus } from "@/api/configurationlist";
import { SetDeviceIp, removeWebCookie, SetDevicePort } from "@/cookie/cookie"
export default {
  name: "remoteWeb",
  props: ['did', 'dsn'],
  data() {
    return {
      window_did: undefined,
      window_dsn: undefined,
      loading: true,
      connectInfo: {
        hostname: '',
        networkLine:'CHINA_MOBILE'
      },
      timer: null,
      count: 0,
      pingStatus: false,
      hbTimer: null,
    };
  },
  methods: {
    async connect() {
      this.loading = true
      try {
        const res = await getDeviceMqttStatus(this.window_dsn)
        if (!res.data.online) {
          this.$message.error(this.$t('lang.webssh.DeviceMQTToffline'));
          this.loading = false;
          return
        }
      } catch (e) {
        this.$message.error(this.$t('lang.webssh.DeviceMQTToffline'));
        this.loading = false;
        return
      }
      try {
        await this.getIp()
      } catch (e) {
        this.$message.error(this.$t('lang.webssh.Failedtoobtainterminaladdress'))
        return
      }
      if (this.timer) {
        clearInterval(this.timer)
      } else {
        this.timer = setInterval(() => {
          if (!this.pingStatus) {
            this.pingStatus = true;
            pingIp({
              deviceSN: this.window_dsn,
              did: this.window_did,
              ip: this.connectInfo.hostname
            }).then(res => {
              if (res.data.code === 0) {
                clearInterval(this.timer)
                this.timer = null;
                this.loading = false;
                SetDeviceIp(this.connectInfo.hostname);
                SetDevicePort('80');
                let { href } = this.$router.resolve({
                  path: `/web/${this.window_did}/${this.window_dsn}`,
                  query: { ip: this.connectInfo.hostname, port: "80", path: '/cgi-bin/luci/' }
                });
                window.open(href, "_blank");
                this.count = 0;
              }
            }).finally(async () => {
              this.count++;
              this.pingStatus = false;
              if (this.count > 3) {
                await logError({
                  deviceSN: this.window_dsn,
                  did: this.window_did,
                  ip: this.connectInfo.hostname,
                })
                clearInterval(this.timer)
                this.timer = null;
                this.$message.error(this.$t('lang.webssh.tunnelErr'))
                this.loading = false
                this.count = 0
              }
            })
          }
        }, 3000);
      }
    },
    getIp() {
      return new Promise((resolve, reject) => {
        getWebsshUrl({
          deviceSN: this.window_dsn,
          did: this.window_did,
          networkLine:this.connectInfo.networkLine
        }).then(res => {
          if (res.data.code == 0) {
            this.connectInfo.hostname = res.data.data
          } else {
            this.$message.error(res.data.error_message)
          }
          resolve()
        }).catch(err => { reject() })
      })
    },
    async unconnect() {
      removeWebCookie()
      if (this.connectInfo.hostname !== '') {
        if (this.timer) {
          clearInterval(this.timer)
          this.timer = null;
          this.connectReady = false;
        }
        try {
          this.loading = true
          await this.disconnectHandler();
          this.loading = false
        } catch {
          this.$message({
            showClose: true,
            message: this.$t('lang.devicelist.disbad'),
            type: "error"
          });
        }
      }
    },
    async disconnectHandler() {
      let ip = this.connectInfo.hostname;
      this.connectInfo.hostname = '';
      const res = await removeDeviceIp({
        ip,
        deviceSN: this.window_dsn,
        did: this.window_did
      })
      if (res.status !== 200) {
        this.$message.error(res.data.message)
      }
    },
  },
  mounted() {
    this.window_did = this.did;
    this.window_dsn = this.dsn;
    setTimeout(() => {
      this.loading = false
    }, 500)
  },
  beforeDestroy() {
    this.unconnect();
  },
};
</script>
<style scoped></style>